import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetCurrentUserQuery } from '../../redux/apis';
import LoadingSpinner from '../ui/LoadingSpinner';

/**
 * Route component that checks if user is authenticated and has a verified
 * Stripe account before allowing access to protected routes like product upload
 */
const StripeVerifiedRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useSelector(state => state.auth);
  
  const { data: user, isLoading } = useGetCurrentUserQuery(undefined, {
    skip: !isAuthenticated,
    refetchOnMountOrArgChange: false,
  });

  return (
    <Route
      {...rest}
      render={props => {
        // Redirect to login if not authenticated
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location }
              }}
            />
          );
        }

        // Show loading spinner while checking user status
        if (isLoading) {
          return (
            <div className="min-h-screen flex items-center justify-center">
              <LoadingSpinner />
            </div>
          );
        }

        // In Beta mode (not launched), bypass Stripe verification
        const isVerified = user?.stripeAccountDetail?.chargesEnabled === true;

        if (!isVerified) {
          return (
            <Redirect
              to={{
                pathname: '/dashboard/wallet',
                state: {
                  from: props.location,
                  message: 'You need to complete Stripe verification before uploading products'
                }
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default StripeVerifiedRoute; 